import { Body, Heading, Sheet, VStack } from '@hover/blueprint';
import { AnimatePresence } from 'framer-motion';
import React, { useCallback } from 'react';
import { generatePath, useHistory } from 'react-router';

import { Masonry } from 'src/modules/homeownerApp/components/Masonry';
import { MasonryImageItem } from 'src/modules/homeownerApp/components/Projects/Menu/ImageCollection/MasonryImageItem';
import { useHomeownerAppContext } from 'src/modules/homeownerApp/hooks';
import type { AiDisplayImage } from 'src/shared/graphql/generated';
import { Route } from 'src/shared/route';

const ImageCollection = () => {
  const history = useHistory<{
    header?: string;
    subtitle?: string;
    projectId: number;
    assets: AiDisplayImage[];
  }>();
  const { setCurrentMenu } = useHomeownerAppContext();
  const { state } = history.location;

  const handleImageClick = useCallback(
    (displayImage: AiDisplayImage) => {
      setCurrentMenu(null);
      history.push(
        generatePath(Route.HOMEOWNER_APP_PROJECT_DISPLAY_FULLSCREEN.path, {
          projectId: history.location.state.projectId,
          aiDisplayImageId: displayImage.id,
        }),
      );
    },
    [history, setCurrentMenu],
  );

  if (!state) return null;

  return (
    <Sheet.Contents
      header={
        <VStack alignItems="flex-start" width="100%">
          <Body
            display={{ base: 'flex', tablet: 'none' }}
            isSemiBold
            marginY="0px"
          >
            {state.header}
          </Body>
          <Heading display={{ base: 'none', tablet: 'flex' }} size={700}>
            {state.header}
          </Heading>
          {state.subtitle && (
            <Body
              color="neutral.500"
              fontSize={{ base: 200, tablet: 400 }}
              mt="0px !important"
            >
              {state.subtitle}
            </Body>
          )}
        </VStack>
      }
      maxContentHeight={{ base: 'calc(100dvh - 75px)', desktop: '70vh' }}
    >
      <Masonry
        columns={{ base: 2, tablet: 3 }}
        fallbackRowHeight={{ base: 250, width250: 300, tablet: 400 }}
        gap={{ base: 300, tablet: 500 }}
        paddingY={300}
        role="list"
        width="100%"
      >
        <AnimatePresence>
          {state.assets?.map(displayImage => {
            if (!displayImage) return null;
            return (
              <MasonryImageItem
                displayImage={displayImage}
                key={displayImage.id}
                onClick={() => handleImageClick(displayImage)}
              />
            );
          })}
        </AnimatePresence>
      </Masonry>
    </Sheet.Contents>
  );
};

export { ImageCollection };
